import React from 'react'
import { Label } from '@workwhile/ui'
import {
  JET_ASSIGNMENT_STATUS_LABELS,
  JET_ASSIGNMENT_STATUS_LABEL_VARIANTS,
  JetAssignmentStatus,
} from 'pages/Jet/shared/constants/assignmentStatus'

export const JetAssignmentStatusBadge = ({
  status,
}: {
  status: JetAssignmentStatus
}) => (
  <Label
    variant={JET_ASSIGNMENT_STATUS_LABEL_VARIANTS[status]}
    size="small"
    style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
  >
    {JET_ASSIGNMENT_STATUS_LABELS[status]}
  </Label>
)
